export type PermissionProject = "swageazy" | "swayy";

export const PERMISSION_PROJECT_OPTIONS: {
  id: string;
  value: string;
}[] = [
  { id: "swageazy", value: "Swageazy" },
  { id: "swayy", value: "Swayy" },
];
